require("!!/home/vsts/work/1/s/emr-webapp/node_modules/script-loader/addScript.js")(require("!!/home/vsts/work/1/s/emr-webapp/node_modules/raw-loader/index.js!/home/vsts/work/1/s/emr-webapp/node_modules/image-compressor.js/dist/image-compressor.min.js"))


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/script-loader!/home/vsts/work/1/s/emr-webapp/~/image-compressor.js/dist/image-compressor.min.js
// module id = ../../../../script-loader/index.js!../../../../image-compressor.js/dist/image-compressor.min.js
// module chunks = 3